import { PropsWithoutRef } from "react";
import tw, { styled } from "twin.macro";

import GetADemoButton from "../buttons/GetADemoButton";
import Container from "../common/Container";
import Section, {
  SectionColor,
  SectionContent,
  SectionCta,
  SectionHeader,
  SectionHeadline,
  SectionHeadlineHighlight,
} from "../common/Section";
import Features from "./Features";

interface ExploreOtherFeaturesProps {
  current: string;
  color?: SectionColor;
}

const ExploreOtherFeatures: React.FunctionComponent<
  PropsWithoutRef<ExploreOtherFeaturesProps>
> = ({ current, color = SectionColor.White, ...props }) => (
  <Container {...props}>
    <Section color={color}>
      <SectionHeader>
        <SectionHeadline tw="text-center">
          Explore{" "}
          <SectionHeadlineHighlight>top features</SectionHeadlineHighlight>
        </SectionHeadline>
      </SectionHeader>
      <SectionContent>
        <Features current={current} linkify={true} />
      </SectionContent>
      <SectionCta buttons={<GetADemoButton />} />
    </Section>
  </Container>
);

export default ExploreOtherFeatures;
